import { replaceTokensInString } from '@cat-ecom/common/utils/stringUtils';
import { getFormattedDate } from 'components/availability-wrapper/utils';
import { DATE_FNS_LOCALES } from 'constants/languageConstants';
import { useTranslations } from 'next-intl';

const StoreAvailabilityByDate = ({ byDate, contactDealer, locale }) => {
  const t = useTranslations();
  return (
    <>
      {byDate.map((item, index) => (
        <tr key={`${item.quantity}-${item.date || 'contact-dealer'}`}>
          <td className="fw-bold d-flex h-100">
            <div className="text-start cat-u-margin-bottom-none">
              {item.date && (
                <>
                  {contactDealer === null
                    ? replaceTokensInString(
                        t('AVAIL_STANDARD_ALL_PICKUP', {
                          0: item.quantity,
                          1: getFormattedDate(
                            item.date,
                            {
                              locale: DATE_FNS_LOCALES[locale]
                            },
                            'MMM'
                          ),
                          2: getFormattedDate(item.date, '', 'dd')
                        })
                      )
                    : replaceTokensInString(
                        t('AVAIL_STANDARD_SOME_PICKUP', {
                          0: item.quantity,
                          1: getFormattedDate(
                            item.date,
                            {
                              locale: DATE_FNS_LOCALES[locale]
                            },
                            'MMM'
                          ),
                          2: getFormattedDate(item.date, '', 'dd')
                        })
                      )}
                </>
              )}
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default StoreAvailabilityByDate;
